module.exports = __webpack_public_path__ + "img/Success@2x.e3d4bd2f.png";